import { useEffect, useState } from 'react';

/** 'dark' when the app has set data-theme="dark" on <html>, otherwise 'light'. */
export function readAtlasTheme() {
  if (typeof document === 'undefined' || !document.documentElement) return 'light';
  return document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
}

/**
 * The current app theme ('light' | 'dark') for canvas / WebGL renderers that cannot read CSS variables.
 * Re-renders when data-theme on <html> changes.
 */
export default function useAtlasTheme() {
  const [theme, setTheme] = useState(readAtlasTheme);

  useEffect(() => {
    // Catch a change that landed between the first render and this effect.
    setTheme(readAtlasTheme());
    if (typeof MutationObserver === 'undefined' || typeof document === 'undefined') return undefined;
    const observer = new MutationObserver(() => setTheme(readAtlasTheme()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] });
    return () => observer.disconnect();
  }, []);

  return theme;
}
